// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBarAdmin_searchBar__6dH+T","searchInput":"SearchBarAdmin_searchInput__z-T23","searchButton":"SearchBarAdmin_searchButton__rjP0d"};